import { Box } from "@mui/material";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";

const MainLayout = ({ children, isLoggedIn, profileName, onLogout }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Smooth-scroll to hash targets when on home route
    if (location.pathname === "/" && location.hash) {
      const id = location.hash.replace("#", "");
      const tryScroll = (retries = 20) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (retries > 0) {
          setTimeout(() => tryScroll(retries - 1), 50);
        }
      };
      // Allow children to render first
      setTimeout(() => tryScroll(), 0);
      return;
    }

    if (location.hash) {
      const base = location.pathname + location.search;
      window.history.replaceState(null, "", base);
    }

    // Default: ensure we start at top when changing pages without hashes
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <NavBar
        isLoggedIn={isLoggedIn}
        profileName={profileName}
        onLogout={onLogout}
      />
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
      <Footer />
    </Box>
  );
};
export default MainLayout;
